import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { GENIE_AVATAR_WRAPPER_DIMENSION, GENIE_TRANSLATE, MAX_VISIBLE_GENIES } from "constants/index"
import Avatar from "components/atoms/Avatar"

type LinearPositionedAvatarsProps = {
  users: Record<string, any>[];
  avatarKey: string
}

export default function LinearPositionedAvatars(props: LinearPositionedAvatarsProps) {
  const { users, avatarKey } = props

  const sliceIndex = users?.length - MAX_VISIBLE_GENIES > 0 ? MAX_VISIBLE_GENIES - 1 : MAX_VISIBLE_GENIES
  return <Stack direction="row" alignItems="center" justifyContent="center">
    {users?.slice(0, sliceIndex).map((user, index) => <AvatarsWrapper
      key={user.id}
      style={{ transform: index > 0 ? `translateX(${GENIE_TRANSLATE * index}px)` : "translateX(0)" }}
    >
      <Avatar imageSrc={user[avatarKey]}/>
    </AvatarsWrapper>)}
    {users?.length - MAX_VISIBLE_GENIES > 0 && <AvatarsWrapper style={{ transform: `translateX(${GENIE_TRANSLATE * (MAX_VISIBLE_GENIES - 1)}px)` }}>
        <InvisibleGeniesCount className="farsi-digits">{users?.length - sliceIndex}+</InvisibleGeniesCount>
    </AvatarsWrapper>}
  </Stack>
}

const AvatarsWrapper = styled("div")(({ theme }) => ({
  width: GENIE_AVATAR_WRAPPER_DIMENSION + "px",
  height: GENIE_AVATAR_WRAPPER_DIMENSION + "px",
  border: `1px solid ${theme.palette.gray["4"]}`,
  borderRadius: "50%",
  flexShrink: 0
}))

const InvisibleGeniesCount = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "100%",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  fontSize: "1.1rem",
  color: "#FFFFFF",
  backgroundColor: theme.palette.primary["5"]
}))
